import axios, { AxiosError } from "axios";
import Auth from "../services/auth/AuthService";

interface ApiErrorResponse {
    message?: string;
}

const api = axios.create({
    baseURL: process.env.REACT_APP_HBSCAN_API,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.response.use(
    (response) => response,
    (error: AxiosError<ApiErrorResponse>) => {
        const { response } = error;
        const status = response?.status;

        if (status === 401) {
            Auth.setAuth(undefined);
        }

        return Promise.reject(error);
    }
);

export default api;
